export const ROUTE_LIST = "ROUTE_LIST";
export const CITY_LIST = "CITY_LIST";
export const ROUTE_LEGS_LIST = "ROUTE_LEGS_LIST";
export const UPDATE_ROUTE = "UPDATE_ROUTE";
export const ROUTE_LIST_DETAILS = "ROUTE_LIST_DETAILS";
export const CLASS_TYPE_LIST_ROUTE = "CLASS_TYPE_LIST_ROUTE";
export const LEVY_TYPE_LIST = "LEVY_TYPE_LIST";
